import React, { Component } from "react";

import "./consultorias_prestadas.css";
import CategoryList from "../category/categoryList";

class ConsultoriasPrestadas extends Component {
  render() {
    return (
      <section className="section-consult">
        <h2 className="textoSecao"> Atendimentos Prestados </h2>
        <CategoryList list={this.props.list} />
      </section>
    );
  }
}

export default ConsultoriasPrestadas;
